<div class="p-4 rounded-xl">

  <div class="flex justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'SETUP.ORG.DEPARTMENT' | translate }}</h2>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'SETUP.ORG.ADD_DEPARTMENT_BUTTON' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
    [enablePagination]="true"
    [pageSize]="10"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    [title]="isEditMode ? 'SETUP.ORG.EDIT_DEPARTMENT_HEAD' : 'SETUP.ORG.ADD_DEPARTMENT_HEAD'"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showAssignPopup"
    title="SETUP.EMPLOYEE_ASSIGNMENT"
    [fields]="assignFields"
    [data]="assignFormData"
    [onSave]="handleAssignSave"
    saveLabel="COMMON.OK"
    type="form"
  ></app-popup>

</div>
